export class Feature {

  id: number;
  name: string;
  label?: string;
  type: string;
  variant_id: string;
  description: string;
  position?: {
    x: number;
    y: number;
  };
  _links: any;
  _embedded: any;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/services/feature/feature.ts